import React from "react";

const Footer = () => {
  return (
    <footer className="mt-16 bg-slate-950 text-white">
      <section className="mx-auto w-full max-w-7xl px-4 py-10 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-[1.2fr_0.8fr] md:items-center">
          <div>
            <div className="flex flex-col items-center gap-3 text-center md:flex-row md:text-left">
              <img
                src="/images/ball_logo.png"
                alt="Student Ball logo"
                className="h-14 w-14 object-contain"
              />

              <div>
                <h3 className="text-2xl font-extrabold uppercase tracking-wide">
                  Student Ball
                </h3>
                <p className="mt-1 text-sm font-medium text-blue-300">
                  Make your moments matter.
                </p>
              </div>
            </div>

            <p className="mt-5 max-w-xl text-center text-sm leading-6 text-slate-300 md:text-left">
              Professional sports media, highlight edits and event content for
              amateur and semi-professional players, teams and tournaments.
            </p>
          </div>

          <div className="flex justify-end mr-0 items-center h-min gap-4 md:items-end">
            <p className="text-sm my-auto font-semibold uppercase tracking-wide text-slate-400">
              Follow Student Ball
            </p>

            <div className="flex items-center gap-3">
              <a
                href="https://instagram.com/studentball"
                target="_blank"
                rel="noreferrer"
                aria-label="Student Ball Instagram"
                className="flex h-11 w-11 items-center justify-center hover:scale-110 rounded-full border border-white/10 bg-white/5 text-xl text-white transition "
              >
                <img src="/images/instagram.svg" alt="Instagram" />
                {/* <i className="fa fa-instagram" /> */}
              </a>

              {/* <a
                href="https://www.youtube.com/@AJSPORTACADEMYCIC"
                target="_blank"
                rel="noreferrer"
                aria-label="YouTube"
                className="flex h-11 w-11 items-center justify-center rounded-full border border-white/10 bg-white/5 text-xl text-white transition hover:border-blue-400 hover:bg-blue-600"
              >
                <i className="fa fa-youtube-play" />
              </a>

              <a
                href="https://www.facebook.com/AJsportacademy/"
                target="_blank"
                rel="noreferrer"
                aria-label="Facebook"
                className="flex h-11 w-11 items-center justify-center rounded-full border border-white/10 bg-white/5 text-xl text-white transition hover:border-blue-400 hover:bg-blue-600"
              >
                <i className="fa fa-facebook" />
              </a> */}
            </div>
          </div>
        </div>

        <div className="my-8 h-px w-full bg-white/10" />

        <div className="flex flex-col items-center justify-between gap-4 text-center text-sm text-slate-400 md:flex-row">
          <p>Copyright © All Rights Reserved. Student Ball 2025</p>

          <p>
            Powered by{" "}
            <a
              className="font-semibold text-blue-300 underline underline-offset-4 transition hover:text-blue-200"
              target="_blank"
              rel="noreferrer"
              href="https://netreach.uk"
            >
              netreach.uk
            </a>
          </p>
        </div>
      </section>
    </footer>
  );
};

export default Footer;